var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Set "),_c('select',{attrs:{"name":"set-select","id":"set-select"}},_vm._l((_vm.sets),function(s){return _c('option',{key:s.code,domProps:{"value":s.code}},[_vm._v(_vm._s(s.name))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }